export type ToolbarItem =
  | 'heading'
  | 'customFontFamily'
  | 'customFontSize'
  | 'fontColor'
  | 'fontBackgroundColor'
  | 'alignment'
  | 'bold'
  | 'italic'
  | 'underline'
  | 'strikethrough'
  | 'superscript'
  | 'removeFormat'
  | 'link'
  | 'mediaEmbed'
  | 'imageUpload'
  | 'htmlEmbed'
  | 'bulletedList'
  | 'numberedList'
  | 'outdent'
  | 'indent'
  | 'blockQuote'
  | 'insertTable'
  | 'customTheme'
  | 'obvioVariable'
  | 'insertCustomButton'

export type ObvioVariable = {
  label: string
  value: string
}

export type EditorTheme = 'Auto' | 'Light' | 'Dark'

export type CustomLinkPreset = {
  name: string
  href: string
}

export const CUSTOM_LINK_MAP: Record<string, string> = {
  Login: '{{login_url}}',
  Leaderboard: '{{leaderboard_url}}',
  leaderboardLink: '{{leaderboard_url}}',
}
